module.exports = __webpack_public_path__ + "static/media/Telegram.f0338e4a.png";